export function universalAtob(inString) {
    if (typeof atob !== "undefined") {
        return atob(inString);
    }
    return Buffer.from(inString, "base64").toString("binary");
}
export function obfuscate(value) {
    return btoa(JSON.stringify(value));
}
export function unobfuscate(value) {
    return JSON.parse(atob(value));
}
